export const errosMessage = {
    ALTERAR_EMAIL:
        'Essa conta já está ativa, ao trocar o e-mail o login atual do usuário será descontinuado e um cadastro novo deverá ser feito. Deseja continuar?',
    IS_REQUIRED: 'Campo é obrigatório.',
    FORMATO_EMAIL_INVALIDO: 'Formato de e-mail inválido',
    ONLY_NUMBERS: 'Deve ser somente número',
    OBSERVACAO: 'Uma observação notificando a rejeição é obrigatório',
};
